import { VolumeReportsState } from "@app/reports/volume-reports/import/interfaces";
import { expandCollapse } from "@app/shared/qes-standards/utility/expandCollapse";
import { FC, useContext, useMemo, useRef } from "react";
import { CheckboxStateEnum, QESCheckbox } from "@app/shared/qes-standards/forms/Checkbox";
import { VolumeReportsContext } from "@app/reports/volume-reports/import/VolumeReportsContext";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";
import { QESButton } from "@app/shared/qes-standards/Button";

interface StateAccordionProps {
    state: VolumeReportsState;
}

export const VolumeReportsStateAccordionWithCheckboxes: FC<React.PropsWithChildren<StateAccordionProps>> = (props: StateAccordionProps) => {
    const wizardContext = useContext(VolumeReportsContext);
    const countyListRef = useRef<HTMLUListElement>(null);
    const iconRef = useRef<HTMLButtonElement>(null);

    const handleOpen = () => {
        iconRef.current.style.transform = "rotate(90deg)";
    }

    const handleClose = () => {
        iconRef.current.style.transform = null;
    }

    const counties = useMemo(() => {
        return props.state.childServiceAreas.filter((child) => child.isVisible).map((child) => (
            <li key={child.displayName}>
                <QESCheckbox
                    label={child.displayName}
                    checked={child.isChecked}
                    testId={`volume-reports__county-checkbox--${props.state.displayName}:${child.displayName}`}
                    onClick={(e) => { e.stopPropagation(); }}
                    onChange={(e) => wizardContext.updateSelectedServiceArea(props.state.displayName, child.displayName, e.target.checked)}
                    onLabelClick={(e) => { e.stopPropagation(); }}
                    containerClassName="vr__checkbox-container"
                />
            </li>
        ));
    }, [props.state.checkboxState, props.state.isVisible, props.state.childServiceAreas]);

    return (
        <ul className="vr__list" onClick={() => { expandCollapse(countyListRef, handleClose, handleOpen); }}>
            <li>
                <QESButton
                    className="vr__collapse-indicator"
                    qesType="none"
                    qesTestId={`vr__list-collapse-toggle--${props.state.displayName}`}
                    onClick={(e) => e.preventDefault()}
                    qesRef={iconRef}
                    disabled={wizardContext.reportType !== "stateaggregate" ? false : true}
                    hidden={wizardContext.reportType !== "stateaggregate" ? false : true}
                >
                    <QesIcon iconName={QesIcons.ChevronRight} description="Expand"/>
                </QESButton>
                <QESCheckbox
                    label={props.state.displayName}
                    checked={props.state.checkboxState === CheckboxStateEnum.Checked}
                    indeterminate={props.state.checkboxState === CheckboxStateEnum.Indeterminate}
                    testId={`volume-reports__state-checkbox--${props.state.displayName}`}
                    onClick={(e) => { e.stopPropagation(); }}
                    onChange={(e) => wizardContext.updateSelectedServiceArea(props.state.displayName, undefined, e.target.checked)}
                    onLabelClick={(e) => { e.stopPropagation(); }}
                />
                <ul className="vr__list qes-js-closed" ref={countyListRef} onClick={(e) => { e.stopPropagation(); }}>
                    {wizardContext.reportType !== "stateaggregate" && counties}
                </ul>
            </li>
        </ul>
    );
}
